// poll.js
document.addEventListener("DOMContentLoaded", () => {
  // We'll store poll data in memory. A real app might call an API.
  // Key: pollId => { [optionName]: voteCount }
  const pollData = {
    "poll-radio": {},
    "poll-checkbox": {},
  };

  // Initialize from localStorage if you want persistence:
  // try {
  //   const stored = JSON.parse(localStorage.getItem("pollData"));
  //   if (stored) pollData = stored;
  // } catch(e) { /* ignore */ }

  // Attach event listener to all poll submit buttons
  const submitButtons = document.querySelectorAll(".poll-submit");
  submitButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const pollId = btn.getAttribute("data-poll-id");
      handleSubmit(pollId);
    });
  });

  function handleSubmit(pollId) {
    const pollSection = document.getElementById(pollId);
    if (!pollSection) return;

    const optionsContainer = pollSection.querySelector(".poll-options");
    const resultContainer = pollSection.querySelector(".poll-results");

    // Distinguish between single-choice (radio) vs multiple-choice (checkbox)
    const inputs = optionsContainer.querySelectorAll("input");

    let selectedValues = [];
    inputs.forEach((inp) => {
      if (inp.type === "radio" && inp.checked) {
        selectedValues.push(inp.value);
      } else if (inp.type === "checkbox" && inp.checked) {
        selectedValues.push(inp.value);
      }
    });

    if (!selectedValues.length) {
      resultContainer.textContent = "Please select at least one option.";
      return;
    }

    // Tally votes in pollData
    if (!pollData[pollId]) {
      pollData[pollId] = {};
    }

    selectedValues.forEach((val) => {
      if (!pollData[pollId][val]) {
        pollData[pollId][val] = 0;
      }
      pollData[pollId][val]++;
    });

    // In a real app, you'd store pollData to server or localStorage:
    // localStorage.setItem("pollData", JSON.stringify(pollData));

    // Now calculate and display results
    displayResults(pollId, resultContainer);
  }

  function displayResults(pollId, resultContainer) {
    const pollVotes = pollData[pollId];
    if (!pollVotes) return;

    // total votes is sum of all option votes
    const totalVotes = Object.values(pollVotes).reduce(
      (acc, val) => acc + val,
      0
    );

    // build a small list of each option with its percentage
    let html = `<h4>Results:</h4><ul>`;
    for (let [option, count] of Object.entries(pollVotes)) {
      let percent = ((count / totalVotes) * 100).toFixed(1);
      html += `<li>${option}: ${percent}% (${count} votes)</li>`;
    }
    html += `</ul>`;
    resultContainer.innerHTML = html;
  }
});

document.querySelectorAll(".md-radio__icon").forEach((icon) => {
  icon.addEventListener("mousedown", (e) => {
    const ripple = document.createElement("span");
    ripple.className = "ripple";
    ripple.style.left = e.offsetX + "px";
    ripple.style.top = e.offsetY + "px";
    icon.appendChild(ripple);

    // Remove after animation
    ripple.addEventListener("animationend", () => {
      ripple.remove();
    });
  });
});
document.querySelectorAll(".md-checkbox__icon").forEach((icon) => {
  icon.addEventListener("mousedown", (e) => {
    const ripple = document.createElement("span");
    ripple.className = "ripple";
    ripple.style.left = e.offsetX + "px";
    ripple.style.top = e.offsetY + "px";
    icon.appendChild(ripple);

    // Remove after animation
    ripple.addEventListener("animationend", () => {
      ripple.remove();
    });
  });
});
